import * as Yup from "yup";

export const updateFeedValidationSchema = Yup.object({
  content: Yup.string().trim().required("Không được để trống"),
  zindex: Yup.number().nullable(),
  status: Yup.number().oneOf([1, 2, 3]).required("Không được để trống"),
});
